import { useTranslation } from 'react-i18next';
// import { useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import {
  DropdownMenuItem,
  DropdownMenuSub,
} from '@/Domain/components/Shared/DropdownMenu/DropdownMenu';
import { Switch } from '@/Domain/components/Shared/Switch/Switch';
import { useAudioNotification } from '@/Domain/hooks/Audio/useAudioNotification.hook';

export const VoiceAlertsDropdown = () => {
  const { t } = useTranslation(['inbox_v2']);
  const { playNotification } = useAudioNotification();

  // const [voiceAlerts, setVoiceAlerts] = useState({
  const [voiceAlerts, setVoiceAlerts] = useLocalStorage('voice_alerts_settings', {
    newConversation: true,
    handoff: true,
    newMessageToMe: true,
    newMessage: false,
  });

  const handleToggleAlert = (alertType: keyof typeof voiceAlerts) => {
    setVoiceAlerts((prev) => ({
      ...prev,
      [alertType]: !prev[alertType],
    }));
    playNotification(alertType, 'toggle');
  };

  return (
    <DropdownMenuSub>
      <DropdownMenuItem
        className="flex items-center justify-between cursor-default [&:hover]:cursor-default [&:hover]:bg-accent"
        onSelect={(e) => e.preventDefault()}
      >
        <span className="cursor-default">{t('setting_dropdown.new_conversation_alert')}</span>
        <div className="cursor-pointer" onClick={(e) => e.stopPropagation()}>
          <Switch
            checked={voiceAlerts.newConversation}
            onCheckedChange={() => handleToggleAlert('newConversation')}
            size="sm"
          />
        </div>
      </DropdownMenuItem>

      <DropdownMenuItem
        className="flex items-center justify-between cursor-default [&:hover]:cursor-default [&:hover]:bg-accent"
        onSelect={(e) => e.preventDefault()}
      >
        <span className="cursor-default">{t('setting_dropdown.handoff_alert')}</span>
        <div className="cursor-pointer" onClick={(e) => e.stopPropagation()}>
          <Switch
            checked={voiceAlerts.handoff}
            onCheckedChange={() => handleToggleAlert('handoff')}
            size="sm"
          />
        </div>
      </DropdownMenuItem>

      <DropdownMenuItem
        className="flex items-center justify-between cursor-default [&:hover]:cursor-default [&:hover]:bg-accent"
        onSelect={(e) => e.preventDefault()}
      >
        <span className="cursor-default">{t('setting_dropdown.new_message_to_me_alert')}</span>
        <div className="cursor-pointer" onClick={(e) => e.stopPropagation()}>
          <Switch
            checked={voiceAlerts.newMessageToMe}
            onCheckedChange={() => handleToggleAlert('newMessageToMe')}
            size="sm"
          />
        </div>
      </DropdownMenuItem>

      <DropdownMenuItem
        className="flex items-center justify-between cursor-default [&:hover]:cursor-default [&:hover]:bg-accent"
        onSelect={(e) => e.preventDefault()}
      >
        <span className="cursor-default">{t('setting_dropdown.new_message_alert')}</span>
        <div className="cursor-pointer" onClick={(e) => e.stopPropagation()}>
          <Switch
            checked={voiceAlerts.newMessage}
            onCheckedChange={() => handleToggleAlert('newMessage')}
            size="sm"
          />
        </div>
      </DropdownMenuItem>
    </DropdownMenuSub>
  );
};
